import { Card } from "@/components/ui/card";
import {
  BooleanField,
  DataTable,
  List,
  ListActions,
  NumberField,
  SearchInput,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const LeaveTypeList = () => (
  <List
    title="Leave Types"
    filters={filters}
    actions={<ListActions label="Add Leave Type" />}
    sort={{ field: "name", order: "ASC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="edit">
        <DataTable.Col
          source="code"
          label="Code"
          className="font-mono text-xs bg-muted px-2 py-0.5 rounded border"
        />
        <DataTable.Col source="name" label="Leave Type" className="font-semibold" />
        <DataTable.Col source="days_per_year" label="Days / Year">
          <NumberField source="days_per_year" />
        </DataTable.Col>
        <DataTable.Col source="paid" label="Paid">
          <BooleanField source="paid" />
        </DataTable.Col>
        <DataTable.Col source="carry_forward" label="Carry Forward">
          <BooleanField source="carry_forward" />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);
